module.exports = __webpack_public_path__ + "media/application-logos/prospect-horizontal-navy-26e97aee.svg";